<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-06 16:00 -->
<!-- Description:  -->
<template>
  <div>
    <div class="mb-3">
      <label for="">Cliente</label>
      <SelectClient v-model="reg.client_id"></SelectClient>
      <app-form-errors :errors="errors.client_id"></app-form-errors>
    </div>

    <div class="mb-3">
      <app-form-errors :errors="errors.products"></app-form-errors>
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>PRODUCTOS</th>
            <th>CANT</th>
            <th>SUB.</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(l, i1) in products" :key="i1">
            <td>{{ l.product_name }}</td>
            <td class="p-0">
              <input type="number" v-model="l.quantity"
                @change="handleChangeQuantity($event, l, i1)" class="input-in-table"
                min="0">
            </td>
            <td>{{ l.sub | money }}</td>
            <td class="p-0">
              <button class="btn btn-sm btn-light" @click="deleteItem(i1)">
                <i class="fas fa-times"></i>
              </button>
            </td>
          </tr>
          <tr>
            <td class="p-0">
              <div class="d-flex w-100">
                <SelectStock 
                  v-model="reg.stock_id"
                  :storeId="reg.store_id"
                  :key="reg.store_id"
                  :withStock="true"
                  @select="handleSelectStock($event)"
                  ref="elSelectStock"
                  placeholder="Selecciona un producto para registrar venta">
                </SelectStock>
                <!-- <button class="btn btn-primary mr-1" type="button" -->
                <!--   @click="handleAddButton()"> -->
                <!--   <i class="fas fa-plus"></i> -->
                <!--   Agregar Producto</button> -->
              </div>
            </td>
          </tr>
          <tr>
            <th></th>
            <th>TOTAL</th>
            <th>
              {{ getTotal() | money }}
            </th>
            <th></th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mb-3">
      <label for="">Metodo de pago</label>
      <SelectPayMethod v-model="reg.pay_method"></SelectPayMethod>
      <app-form-errors :errors="errors.pay_method"></app-form-errors>
    </div>
    <div class="mb-3">
      <button class="btn btn-success mr-1" type="button" 
        @click="save()" :disabled="sending">
        <i class="fas fa-print"></i>
        Registrar Venta
      </button>
      <a class="btn btn-secondary" v-if="sale.id" :href="linkToPrintSale()">
        <i class="fas fa-print"></i>
        Imprimir Venta
      </a>
    </div>
  </div>
</template>
<script>
import SelectClient from "src/lt/store-module/clients/Select.vue";
import SelectStock from "src/lt/logistic-module/stock/Select.vue";
import {LogisticService} from "src/lt/logistic-module/service.js";
import SelectPayMethod from "src/lt/general-module/SelectPayMethod.vue";
import StoreService from "src/lt/store-module/StoreService.js";
import validator from "src/lt/utils/validator.js";

const rules = {
  client_id: { presence: { allowEmpty: false } },
  pay_method: { presence: { allowEmpty: false } },
  products: { length: { minimum: 1, tooShort: "Agrega al menos un producto" } },
}
export default {
  name: "StoreSaleForm",
  components: {
    SelectClient,
    SelectStock,
    SelectPayMethod,
  },

  // directives

  props: {
    disabled: { default: false },
    content: {
      default: null,
    }
  },

  data: () => ({
    sending: false,
    client: {},
    products: [],
    reg: {},
    stock: {},
    sale: {},
  }),

  computed: {
    errors() { 
      return validator({
        ...this.reg,
        products: this.products,
      }, rules, { fullMessages: false });
    }
  },

  // watch: {},

  created() {
    if(this.content) {
      this.reg = this.content;
    }
  },

  methods: {
    async save() {
      this.sending = true;
      let res = await StoreService.saveSale({
        observation: "",
        pay: this.getTotal(),
        pay_change: 0,
        pay_method: this.reg.pay_method,
        client_id: this.reg.client_id,
        products: this.products.map(x => {
          return {
            quantity: x.quantity,
            unit_price: x.unit_price,
            id: x.product_id,
            store_id: this.reg.store_id,
          };
        }),
      });
      this.sale = res;
      this.$emit("saved", res);
      // this.sending = false;
    },
    reset() { this.sending =false; },
    setValue() {},
    handleSelectStock(ev) {
      this.stock = ev;
      this.handleAddButton();
    },
    handleAddButton() {
      let pos = this.products.map(x => x.product_id)
        .indexOf(this.stock.product_id);
      if(pos === -1) {
        this.products.push({
          product_name: this.stock.product.name,
          product_id: this.stock.product_id,
          quantity: 1,
          unit_price: parseFloat(this.stock.product.unit_price),
          sub: parseFloat(this.stock.product.unit_price)
        });
        this.$refs.elSelectStock.reset();
      }
    },
    deleteItem(i1) {
      this.products.splice(i1, 1);
    },
    getTotal() {
      return this.products.reduce((p, c) => {
        return p + (parseFloat(c.unit_price) * parseInt(c.quantity));
      }, 0);
    },
    handleChangeQuantity(ev, item, it) {
      this.products[it].sub = parseFloat(item.unit_price) * parseInt(item.quantity);
    },
    linkToPrintSale() {
      return (process.env.VUE_APP_API_URL) + 'print/store/sales/' + this.sale.id;
    }
  }
};
</script>
<style scoped></style>

